import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {get as getRecord, update as updateRecord} from "app/requests/admin/cases";
import Submission from "components/helpers/admin/case-submission";
import Loading from "components/pages/loading";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import Form from "./form";

export default function AdminCasesEdit() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const {uid} = useParams();
  const [block, setBlock] = useState(false);
  const [changes, setChanges] = useState({});
  const [record, setRecord] = useState(null);
  const onChange = ({target}) => {
    setBlock(true);
    setChanges({...changes, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    const updates = {...changes};
    if(updates.keywords) {
      updates.keywords = updates.keywords.split(",").map((k) => k.trim());
    }
    if(Object.keys(updates).length === 0) {
      return dispatch(createNotification({
        content: "Please make changes before submitting",
        type: "danger"
      }));
    }

    setBlock(false);
    updateRecord(record.uid, {record: updates}).then(({message, success}) => {
      if(success) {
        navigate("/admin/cases", {state: {message, type: "success"}});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({
    defaultValue,
    name,
    objects: [changes, record]
  });

  usePrompt({when: block});
  useEffect(() => {
    getRecord(uid).then((data) => {
      setRecord({...data.record, keywords: data.record.keywords.join(", ")});
    });
  }, []);

  if(!record) { return <Loading />; }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6">
          <h1 className="text-center">Edit Case</h1>
          <Form {...{onChange, onSubmit, value}} />
        </div>
        <div className="col-md-4 offset-md-2">
          <h1 className="text-center">Case Submission</h1>
          <Submission record={record.case_submission} />
        </div>
      </div>
    </div>
  );
}
